module.exports = __webpack_public_path__ + "static/media/ic_media_not_found.cb211aee.svg";